import Vue from 'vue';
import App from './App.vue';
import dayjs from 'dayjs';
import store from './store';

if (typeof window.fetch === 'undefined') {
    window.fetch = fetch;
}

Vue.prototype.dayjs = dayjs;

Vue.config.productionTip = false;

new Vue({
    store,
    render: (h) => h(App),
}).$mount('#app');
